import { useSelector } from 'react-redux';
import { myAccountSelector } from 'state/selectors/account';
import {
  isAdmin,
  isSuperUser,
  isViewer
} from 'common/services/accounts.service';

const useAccountType = () => {
  const myAccount = useSelector(myAccountSelector);
  const isUserAdmin = isAdmin(myAccount);
  const isUserSuperUser = isSuperUser(myAccount);
  const isCurrentUserAdminOrSuperUser = isUserAdmin || isUserSuperUser;
  const isUserViewer = isViewer(myAccount);

  return {
    isUserAdmin,
    isUserSuperUser,
    isUserViewer,
    isCurrentUserAdminOrSuperUser
  };
};

export default useAccountType;
